export class FetchResponseError extends Error {
  readonly status: number
  readonly statusText: string
  readonly response: Response
  constructor(response: Response) {
    super('Le serveur a retourné une erreur')
    this.status = response.status
    this.statusText = response.statusText || `Erreur HTTP ${response.status}`
    this.response = response.clone()
  }
}
